<lns-sidebar-header *ngIf="selectedLocation">
  <div class="sidebar-header">
    <div class="header-icon">
      <img
        *ngIf="selectedLocation.locationType.category === 'ic_location_category_atm'"
        src="assets/images/locations/ic_location_category_atm.svg"
        alt=""
      />
      <img
        *ngIf="selectedLocation.locationType.category === 'ic_location_category_branch'"
        src="assets/images/locations/ic_location_category_branch.svg"
        alt=""
      />
      <img
        *ngIf="selectedLocation.locationType.category === 'ic_location_category_safe'"
        src="assets/images/locations/ic_location_category_safe.svg"
        alt=""
      />
    </div>
    <div class="sidebar-title mt-24 text-center">
      {{ selectedLocation.address }}
    </div>
  </div>
</lns-sidebar-header>

<div class="w-full" *ngIf="selectedLocation">
  <div class="mt-24">
    <div class="text-gray">
      {{ 'lbs_location_type' | translate | uppercase }}
    </div>
    <div>{{ selectedLocation.locationType.typeName }}</div>
  </div>
  <div class="mt-24" *ngIf="selectedLocation.workingTime">
    <div class="text-gray">
      {{ 'lbs_filter_working_hours' | translate | uppercase }}
    </div>
    <div>{{ selectedLocation.workingTime }}</div>
  </div>
  <div class="mt-24" *ngIf="selectedLocation.phoneNumber">
    <div class="text-gray">
      {{ 'lbs_phone_number' | translate | uppercase }}
    </div>
    <div>{{ selectedLocation.phoneNumber }}</div>
  </div>
  <div class="mt-24" *ngIf="selectedLocation.email">
    <div class="text-gray">
      {{ 'lbs_email' | translate | uppercase }}
    </div>
    <div>{{ selectedLocation.email }}</div>
  </div>
</div>
